import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ContinueButton from "../../Registration/ContinueButton";
import { useSelector } from "react-redux";

const StatusVerificationForm = ({ onNext }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const userRole = useSelector((state) => state.formData.accountType);
  const formData = location.state || {
    account_status: "Pending",
    verification_status: "Unverified",
    verified_by: "",
    verification_date: "",
  };

  return (
    <>
      <section className="flex flex-col items-center min-h-screen justify-start bg-white py-10 px-6">
        <header className="text-center mb-14">
          <h1 className="text-2xl font-semibold text-[#1D2639]">
            Status & Verification
          </h1>
          <p className="text-base font-medium text-[#7E7E7E] w-full sm:w-[572px] mt-2">
            Thank you! We've received your information and will review it
            shortly. You'll get an email notification once your profile is
            activated.
          </p>
        </header>
        <div className="flex flex-col w-full sm:w-[572px] px-5 py-12 gap-4 bg-[#F9F9F9] rounded-lg border border-gray-300">
          <p className="text-base text-start text-[#1D2639]">
            <strong>Account Status:</strong> {formData.account_status}
          </p>
          <p className="text-base text-start text-[#1D2639]">
            <strong>Verification Status:</strong> {formData.verification_status}
          </p>
          {formData.verified_by && (
            <p className="text-base text-[#1D2639]">
              <strong>Verified By:</strong> {formData.verified_by}
            </p>
          )}
          {formData.verification_date && (
            <p className="text-base text-[#1D2639]">
              <strong>Verification Date:</strong> {formData.verification_date}
            </p>
          )}
        </div>

        <ContinueButton
          label="Proceed to profile"
          onClick={() => {
            if (userRole === "SUPPLIER") {
              navigate("/supplier-dashboard");
            }
          }}
        />
      </section>
    </>
  );
};

export default StatusVerificationForm;